import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    document.title = "Dental Treatments & Services — Manasvi Dental, Kota";
    api.get("/treatments").then(r => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="anim-fade-up">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <span className="text-xs uppercase tracking-[0.25em] text-primary">Our Treatments</span>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight mt-3 max-w-3xl">Every treatment you&apos;d ever need, thoughtfully done.</h1>
        <p className="mt-6 text-lg text-muted-foreground max-w-2xl">From routine hygiene visits to full-mouth rehabilitation — we deliver premium-grade dentistry with warmth.</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(t => (
            <div key={t.id} className="bg-card border border-border rounded-2xl p-8 transition-all hover:-translate-y-1 hover:shadow-md" data-testid={`services-card-${t.slug}`}>
              <div className="w-12 h-12 rounded-xl bg-accent/20 grid place-items-center mb-5"><Sparkles className="w-5 h-5 text-accent-foreground" /></div>
              <h3 className="font-serif text-2xl mb-2">{t.name}</h3>
              <p className="text-sm text-muted-foreground mb-5 min-h-[60px]">{t.description}</p>
              <div className="flex items-center justify-between text-sm border-t border-border pt-4">
                <span><span className="text-muted-foreground">From </span><span className="text-primary font-medium">{t.price}</span></span>
                <span className="text-muted-foreground">{t.duration}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-serif text-3xl sm:text-4xl">Not sure which treatment you need?</h2>
            <p className="mt-2 text-primary-foreground/85">Book a free consultation and we&apos;ll guide you.</p>
          </div>
          <Link to="/book"><Button size="lg" className="rounded-full bg-background text-foreground hover:bg-background/90 h-12 px-8" data-testid="services-book-btn">Book Free Consultation <ArrowRight className="ml-2 w-4 h-4" /></Button></Link>
        </div>
      </section>
    </div>
  );
}
